import '../../styles/sections/section-2-price-card.scss'
import 'slick-carousel'
import $ from 'jquery'


$(`.two-card-slider`).slick(
    {
        slidesToShow:2,
        slidesToScroll:1,
        arrows:false,
        dots:true,
        responsive:[
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                    dots: true,
                    centerMode: true,
                    infinite: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: true,
                    centerPadding: `30px`,
                    infinite: false
                }
            },
            {
                breakpoint: 400,
                settings: {
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: true,
                    centerPadding: `15px`,
                    infinite: false
                }
            }
        ]
    }
)
